// extracted by mini-css-extract-plugin
module.exports = {"transferType":"TypeGridCell_transferType__3CWMy"};